import { useState, useEffect } from "react";

import { DashboardLayout } from "./../../Components/Layout/DashboardLayout";

import "./style.css";
import { RiFileHistoryLine } from "react-icons/ri";

export const Dashboard = () => {
  const [orderTotal, setOrderTotal] = useState(0);

  const fetchDashboardAnalytics = (LogoutData) => {
    let url = `${process.env.REACT_APP_BASE_URL}/admin/dashboard-analytics`;
    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${LogoutData}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        
        setOrderTotal(data?.data?.order_total);
      })
      .catch((error) => {
        console.log("Error in fetching Error", error);
      });
  };
  useEffect(() => {
    const LogoutData = localStorage.getItem("login");
    fetchDashboardAnalytics(LogoutData);
  }, []);

  useEffect(() => {
    document.title = "Virtual PI | Dashboard";
  }, []);

  return (
    <>
      <DashboardLayout>
        <div className="container-fluid">
          <div className="row mb-3">
            <div className="col-12">
              <div className="dashCard">
                <div className="row">
                  <div className="col-xl-3 col-md-6 stats">
                    <div className="statsCard">
                      <div className="statsContent">
                        <div className="statsData">
                          {/* {leadLoading ? 'Loading...' : <h3 className="statsNumber">{`$ ${data?.totalSum}`}</h3>} */}
                          <p className="statsNumber">Total Orders</p>
                          <h3 className="statsText">${orderTotal|| 0}</h3>
                        </div>
                      </div>
                      <div className="statsChange">
                        <RiFileHistoryLine size={24} />
                        {/* <FontAwesomeIcon icon={RiFileHistoryLine} className="me-2  fs-3" /> */}
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-xl-3 col-md-6 stats">
                    <div className="statsCard">
                      <div className="statsContent">
                        <div className="statsData">
                           <h3 className="statsNumber">{events?.length}</h3>
                          <p className="statsText">Total Events</p>
                        </div> 
                      </div>
                      <div className="statsChange">
                      <FontAwesomeIcon icon={faCalendarDays} className="me-2  fs-3" />
                        
                      </div>
                    </div>
                  </div> */}
                  {/* <div className="col-xl-3 col-md-6 stats">
                    <div className="statsCard">
                      <div className="statsContent">
                        <div className="statsData">
                          <h3 className="statsNumber">{programs?.length}</h3>
                          <p className="statsText">Total Programs</p>
                        </div>
                      </div>
                      <div className="statsChange">
                        <img src={program} style={{width:'30px'}} className="me-2" />
                        
                      </div>
                    </div>
                  </div> */}
                  {/* <div className="col-xl-3 col-md-6 stats">
                    <div className="statsCard">
                      <div className="statsContent">
                        <div className="statsData">
                          <h3 className="statsNumber">{sponsors?.length}</h3>
                          <p className="statsText">Total Sponsor Programs</p>
                        </div>
                      </div>
                      <div className="statsChange">
                        <p>
                          
                        </p>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
          {/* <div className="row mb-3">
            <div className="col-12">
              <div className="dashCard">
                <div className="d-flex flex-wrap justify-content-between">
                  <h3 className="mainTitle">Total Users</h3>
                  
                </div>
                <div className="graph-wrapper">
                  <CChart
                    type="line"
                    height="90"
                    options={{
                      scales: {
                        y: {
                          suggestedMin: 0,
                          suggestedMax: 40,
                        },
                      },
                    }}
                    data={{
                      labels: ["Nov 2010", "Dec 2010", "Jan 2011", "Feb 2011","Jul 2011", "Dec 2011"],
                      tension: "0.5",
                      datasets: [
                        {
                          label: "Active Users",

                          backgroundColor: "rgb(0 41 59 / 81%)",
                          borderColor: "#00293B",
                          pointBackgroundColor: "#00293B",
                          pointBorderColor: "#00293B",
                          borderWidth: 2,
                          data: [35,20,30,38,45,52],
                          tension: 0.5,
                        },
                        {
                          label: "Inactive Users",
                          backgroundColor: "rgb(1 22 215 / 81%)",
                          borderColor: "#0116d7",
                          pointBackgroundColor: "#0116d7",
                          borderWidth: 2,
                          pointBorderColor: "#0116d7",
                          data: [20,23,30,26,34,35],
                          tension: 0.5,
                        },
                      ],
                    }}
                  />
                  {users?.length === 0 ? <p className="text-center">No data available</p> : (
                    <CChart
                      type="line"
                      height="90"
                      options={{
                        scales: {
                          x: {
                            title: {
                              display: true,
                              text: "Date",
                            },
                          },
                          y: {
                            title: {
                              display: true,
                              text: "Number of Volunteers",
                            },
                            suggestedMin: 0,
                            // suggestedMax: Math.max(...Object.values(chartData).map(dataset => Math.max(...dataset.data))) + 5, // Dynamically adjust max Y axis
                          },
                        },
                      }}
                      data={chartData}
                    />

                  )}
                </div>
              </div>
            </div>
          </div> */}
          {/* <div className="row mb-3">

          </div> */}
        </div>
      </DashboardLayout>
    </>
  );
};
